var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.vendor?.whatsappNo?.split(',')?.length > 0)?_c('v-btn',{staticClass:"mr-4",style:(`margin-bottom: ${_vm.moreBottomMargin ? '100px' : '40px'}`),attrs:{"fab":"","href":_vm.urlEncodedMsg,"target":"_blank","fixed":"","bottom":"","right":""}},[_c('v-icon',[_vm._v("mdi-face-agent")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }